import { render, staticRenderFns } from "./MessageSidePanel.vue?vue&type=template&id=4f4f5b2e"
import script from "./MessageSidePanel.vue?vue&type=script&lang=js"
export * from "./MessageSidePanel.vue?vue&type=script&lang=js"
import style0 from "./MessageSidePanel.vue?vue&type=style&index=0&id=4f4f5b2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports